module.exports = __webpack_public_path__ + "static/media/2012-normalized.06a17ebc.csv";